import { TableCell, Typography } from "@mui/material"
import { formatDate } from "utils/HelperFunctions"

function NotesTableRows({ note }) {
  return (
    <>
      <TableCell align="left">
        <Typography variant='body'>{formatDate(note.noteDate)}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{`${note.createdBy.firstName} ${note.createdBy.lastName}`}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{note.text || '-'}</Typography>
      </TableCell>
    </>
  )
}

export default NotesTableRows